import * as angular from "angular";

angular.module("theme", ["ngMaterial"]).config(($mdThemingProvider: any) => {
    const primaryColor = "#169265";
    const main = $mdThemingProvider.extendPalette("green", {
        500: "#169265",
        300: "#169265", //notification number colour
        600: "#169265",
        700: "#0e7551",
        800: "#169265",
        A100: "#169265",
        A200: "#169265",
        A300: "#169265",
        A400: "#3949ab",
        A500: "#aa47bc",
        A600: "#34691e",
        A700: "#005770",
        contrastDefaultColor: "light",
    });
    $mdThemingProvider.definePalette("main", main);

    const grey = $mdThemingProvider.extendPalette("grey", {
        50: "#f0f6f8",
    });

    $mdThemingProvider.definePalette("navbarPalette", {
        50: primaryColor,
        100: primaryColor,
        200: primaryColor,
        300: primaryColor,
        400: primaryColor,
        500: primaryColor,
        600: primaryColor,
        700: primaryColor,
        800: primaryColor,
        900: primaryColor,
        A100: primaryColor,
        A200: primaryColor,
        A400: primaryColor,
        A700: primaryColor,
        contrastDefaultColor: "light",
        contrastDarkColors: [
            "50",
            "100",
            "200",
            "300",
            "A100",
            "A200",
            "A400",
            "A700",
        ],
        contrastLightColors: ["400", "500", "600", "700", "800", "900"],
    });

    $mdThemingProvider.definePalette("darkBrand", {
        50: "#0D1329",
        100: "#0D1329",
        200: "#0D1329",
        300: "#0D1329",
        400: "#0D1329",
        500: "#0D1329",
        600: "#0D1329",
        700: "#0D1329",
        800: "#0D1329",
        900: "#0D1329",
        A100: "#0D1329",
        A200: "#0D1329",
        A400: "#0D1329",
        A700: "#0D1329",
        contrastDefaultColor: "light",
    });

    $mdThemingProvider
        .theme("darkBackground")
        .primaryPalette("darkBrand")
        .accentPalette("darkBrand")
        .warnPalette("red")
        .backgroundPalette("darkBrand")
        .dark();

    $mdThemingProvider
        .theme("navbar")
        .primaryPalette("navbarPalette")
        .accentPalette("navbarPalette")
        .warnPalette("red")
        .backgroundPalette("grey");

    $mdThemingProvider.definePalette("brandGrey", grey);

    $mdThemingProvider.definePalette("white", {
        50: "#000",
        100: "#000", //tab item non selected colour
        200: "#000", //body background colour
        300: "#000",
        400: "#000", //search box
        500: "#000",
        600: "#000", //select option selected
        700: "#000",
        800: "#000",
        900: "#000",
        A100: "#000",
        A200: "#000", //toolbar background color
        A300: "#000",
        A400: "#000",
        A700: "#000",
        contrastDefaultColor: "dark", // whether, by default, text (contrast)
    });

    $mdThemingProvider
        .theme("default")
        .primaryPalette("main")
        .accentPalette("white")
        .warnPalette("red")
        .backgroundPalette("brandGrey");
});
